import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Section = styled.div`
  background-color: #1f1f1f;
  border-bottom: 2px solid #2f2f2f;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1100;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
`;

const NavbarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 95px;
  max-width: 1200px;
  width: 100%;
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: #45a049;
  font-size: 1.5rem;
  font-weight: bold;

  &:hover {
    color: #3c8c42;
  }
`;

const PictureFrame = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: #2e2f2e;
  border: 2px solid #45a049;
  overflow: hidden;

  &:hover {
    border: 2px solid #3c8c42;
  }
`;

const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const LinksContainer = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const NavLink = styled(Link)`
  color: #aaaaaa;
  font-size: 1.1rem;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: #45a049;
  }
`;

const Navbar = () => {
  return (
    <Section>
      <NavbarContainer>
        <LogoContainer to="/">
          <PictureFrame>
            <LogoImage src="/assets/pingcraftlogo.png" alt="Pingcraft Support Logo" />
          </PictureFrame>
          Pingcraft Support
        </LogoContainer>
        <LinksContainer>
          <NavLink to="/">Contact Us</NavLink>
          <NavLink to="/">Sign in</NavLink>
        </LinksContainer>
      </NavbarContainer>
    </Section>
  );
};

export default Navbar;
